export const projectList = [
  {
    title: "Grocery Express",
    techStack: ["React", "Ruby on Rails", "PostgreSQL"],
    imgUrl:
      "https://res.cloudinary.com/dszflj9df/image/upload/v1638376856/thumbnails/grocery-express_daa1qs.png",
    deployUrl: "https://grocery-express.netlify.app/",
    gitHub: "https://github.com/ktbg/grocery-express",
    description:
      "Grocery Express is a full stack solo project built with a Ruby on Rails and PostgreSQL back end and React front end. This application allows users to interact with product ratings which are then attributed to the user and stored in the database.",
  },
  {
    title: "TASQ",
    techStack: ["React", "Tailwindcss"],
    imgUrl:
      "https://res.cloudinary.com/dszflj9df/image/upload/v1638376861/thumbnails/tasq_r3wtix.png",
    deployUrl: "https://tasq.netlify.app/",
    gitHub: "https://github.com/ktbg/tasq",
    description:
      "TASQ is a to do list application employing a relational database built using Airtable with a React front end. TASQ enables users to create, edit and manage lists.",
  },
  {
    title: "EVNTZ",
    techStack: ["React", "Express", "Node.js", "MongoDB", "bcrypt", "JWT"],
    imgUrl:
      "https://res.cloudinary.com/dszflj9df/image/upload/v1638376854/thumbnails/evntz_vruhiw.png",
    deployUrl: "https://suspicious-shirley-aff7c1.netlify.app/",
    gitHub: "https://github.com/erik-eyler/EVNTZ",
    description:
      "EVNTZ is a full stack web application built as a team project. The goal is to connect members of the fictitious Newcastle, NJ through community events. Full user authentication allows registered users to create and modify events for their community.",
  },

  {
    title: "Connoisseur",
    techStack: ["HTML", "CSS", "JavaScript"],
    imgUrl:
      "https://res.cloudinary.com/dszflj9df/image/upload/v1638376851/thumbnails/connoisseur_xktktu.png",
    deployUrl: "https://ktbg.github.io/connoisseur/",
    gitHub: "https://github.com/ktbg/connoisseur",
    description:
      "The goal of this project was to consume a third party API and render content. Using axios and JavaScript, get requests were made to the Metropolitan Museum of Art API to return randomized works on page load or user search results.",
  },
];
